import { localizedPath } from '../routes/pathHelpers';
import { Language, RouteKey, RouteParams } from '../routes/routeConfig';

export const SITE_URL = 'https://chipet.app';
export const SITE_NAME = 'ChiPet';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;

interface BreadcrumbItem {
  name: string;
  routeKey: RouteKey;
  params?: RouteParams;
}

export function buildBreadcrumbJsonLd(items: BreadcrumbItem[], lang: Language) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${SITE_URL}${localizedPath(item.routeKey, item.params, lang)}`,
    })),
  };
}

export const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/logo512.jpg`,
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'rehab@chipet.app',
    telephone: '+36303017733',
    contactType: 'customer service',
  },
};

export const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  url: SITE_URL,
  inLanguage: ['hu', 'en'],
};
